import React from 'react';
import { ClipboardList, FileText, BarChart3, Settings, Zap } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
export function ServicesSection() {
  const {
    t
  } = useLanguage();
  const services = [{
    icon: ClipboardList,
    title: t('services.items.projectSupport.title'),
    description: t('services.items.projectSupport.desc')
  }, {
    icon: FileText,
    title: t('services.items.documentation.title'),
    description: t('services.items.documentation.desc')
  }, {
    icon: BarChart3,
    title: t('services.items.technical.title'),
    description: t('services.items.technical.desc')
  }, {
    icon: Settings,
    title: t('services.items.coordination.title'),
    description: t('services.items.coordination.desc')
  }, {
    icon: Zap,
    title: t('services.items.nonStandard.title'),
    description: t('services.items.nonStandard.desc')
  }];
  return <section id="about" className="w-full py-16 px-6 md:px-12 bg-white" data-id="element-272">
      <div className="max-w-7xl mx-auto" data-id="element-273">
        {/* About pill */}
        <div className="inline-block px-4 py-1.5 border border-gray-200 rounded-full mb-6" data-id="element-274">
          <span className="text-sm font-medium text-[var(--color-text-dark)]" data-id="element-275">
            {t('services.pill')}
          </span>
        </div>

        <div className="flex flex-col lg:flex-row gap-12" data-id="element-276">
          {/* Left side - Sticky on desktop */}
          <div className="lg:w-2/5 lg:sticky lg:top-24 lg:self-start" data-id="element-277">
            <h2 className="text-3xl md:text-4xl font-bold text-[var(--color-text-dark)] mb-6 leading-tight whitespace-pre-line" data-id="element-278">
              {t('services.title')}
            </h2>
            <p className="text-[var(--color-text-light)] text-sm leading-relaxed mb-4" data-id="element-279">
              {t('services.desc1')}
            </p>
            <p className="text-[var(--color-text-light)] text-sm leading-relaxed" data-id="element-280">
              {t('services.desc2')}
            </p>
          </div>

          {/* Right side - Scrollable grid */}
          <div className="lg:w-3/5" data-id="element-281">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-282">
              {services.map((service, index) => <div key={index} className="p-6 bg-white border border-gray-100 rounded-xl hover:border-gray-200 transition-colors" data-id="element-283">
                  <service.icon className="w-6 h-6 text-[var(--color-tan)] mb-4" strokeWidth={1.5} data-id="element-284" />
                  <h3 className="text-base font-semibold text-[var(--color-text-dark)] mb-2" data-id="element-285">
                    {service.title}
                  </h3>
                  <p className="text-sm text-[var(--color-text-light)]" data-id="element-286">
                    {service.description}
                  </p>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}